/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs'; 
import { AdmissionMasterApi } from '../api/admissionMaster.api';
import { switchMap, map } from 'rxjs/operators';
import { AdmissionMaster,AdmissionMasterData } from '../../../interfaces/Ip/admissionMaster';

@Injectable()
export class AddmissionMasterService extends AdmissionMasterData {

  constructor(private api: AdmissionMasterApi) {
    super();
  }


  list(url: string): Observable<AdmissionMaster[]> {
    return this.api.list(url);
  }

  getById(url: string): Observable<AdmissionMaster>{
      return this.api.getById(url);
  }

  create(url: string, data: AdmissionMaster): Observable<AdmissionMaster[]> {
    return this.api.add(url,data);
  }

  update(url: string, data: AdmissionMaster): Observable<AdmissionMaster> {
    return this.api.update(url,data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
